import { withContext } from "../routes/registry";

/**
 * ═══ LES ADRESSES DE L'ÉCRAN DE SALLE ═══
 *
 * Reprises de l'ancien gestionnaire d'écrans (`Screens.tsx`, retiré avec les écrans à
 * lien et à jeton) : l'écran de salle s'ouvre maintenant avec le code de l'événement,
 * mais celle où `/ecran` envoie le poste reste. Celle que la salle donnait au public
 * est partie avec le QR code de l'attente (tâche #374).
 */

/**
 * L'adresse de l'écran de salle, la clé de l'écran comprise (le code de l'événement).
 *
 * ⚠️ L'ALIAS EST ÉCHAPPÉ. Un accent y a déjà cassé la reconnaissance d'écran une fois
 * sur ce projet, et un `#` était pire qu'une gêne : tout ce qui suit devient un
 * fragment, donc `?screen=…` ne part jamais au serveur, et le projecteur s'ouvre sans
 * clé sur une adresse qui a l'air juste.
 */
export function screenUrl(
  origin: string,
  context: string | undefined,
  token: string,
): string {
  return `${origin}${eventPath("/live/scene", context)}?screen=${encodeURIComponent(token)}`;
}

/**
 * Une adresse écrite pour être RECOPIÉE (celle de `/ecran`, dans la régie) : sans le
 * protocole, que personne ne tape, et avec ses accents, que l'échappement avait
 * changés en `%C3%A9`. `decodeURI` garde échappé ce qui couperait l'adresse (`%23`
 * reste `%23`).
 */
export function shownUrl(url: string): string {
  return decodeURI(url).replace(/^https?:\/\//, "");
}

const eventPath = (path: string, context: string | undefined) =>
  withContext(path, context ? encodeURIComponent(context) : undefined);
